import apiClient from './apiClient';
import useApiWrapper from './apiWrapper';

/**
 * Build a URL with query parameters from a filters object.
 */
const buildUrl = (baseUrl, filters = {}) => {
  const queryParams = new URLSearchParams();

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      queryParams.append(key, value);
    }
  });

  return queryParams.toString()
    ? `${baseUrl}?${queryParams.toString()}`
    : baseUrl;
};

/**
 * CRUD hook — returns { fetch, create, update, remove }.
 * All methods use PUT (not PATCH) for updates.
 */
const useApiMethods = () => {
  const { apiWrapper } = useApiWrapper();

  const request = (method, url, data = null, options = {}, setLoading) => {
    return apiWrapper(
      () => apiClient.request({ method, url, data, ...options }),
      setLoading
    );
  };

  /** GET with optional query filters */
  const fetch = (url, filters = {}, setLoading) => {
    const fullUrl = buildUrl(url, filters);
    return request('get', fullUrl, null, {}, setLoading);
  };

  /** POST */
  const create = (url, data, isFormData = false, setLoading) => {
    const headers = {
      'Content-Type': isFormData ? 'multipart/form-data' : 'application/json',
    };
    return request('post', url, data, { headers }, setLoading);
  };

  /** PUT (not PATCH — CORS blocks PATCH) */
  const update = (url, data, isFormData = false, setLoading) => {
    const headers = {
      'Content-Type': isFormData ? 'multipart/form-data' : 'application/json',
    };
    return request('put', url, data, { headers }, setLoading);
  };

  /** DELETE */
  const remove = (url, data, setLoading) => {
    return request('delete', url, data, {}, setLoading);
  };

  return { fetch, create, update, remove };
};

export default useApiMethods;
